export const getDossierRelatedDossiersConf = state => state.dossierRelatedDossiers
